import React, { useContext } from "react";
import {
    ModalOverlay,
    ModalWrapper,
    ModalContent,
    TextBlock,
    Title,
    FooterContent,
    CloseActionButton,
    CloseButtonText,
    StyledList,
    StyledListItem,
} from "./AnalyzeStyle";
import Info from "../../images/analyze/info_analyze.svg";
import { ApplicationContext } from "../../components/ApplicationProvider";
import Parser from "html-react-parser";

const AnalyzeSaaSModal: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
    const { t } = useContext(ApplicationContext);
    const printServerSetupLink = `https://support.stratasys.com/en/Software/GrabCAD-Print/Getting-Started/Printing-and-monitoring-remotely-with-GrabCAD-Print-Server`;
    const IOTGatewaySetupLink = `https://support.stratasys.com/en/Software/IoT-Platform`;
    return (
        <ModalOverlay onClick={onClose}>
            <div onClick={(e) => e.stopPropagation()}>
                <ModalWrapper>
                    <ModalContent>
                        <img src={Info} />
                        <TextBlock>
                            <Title>{t("analyze_selection.analyze_modal.modal_title")}</Title>
                            <p>{Parser(t("analyze_selection.analyze_modal.modal_description"))}</p>
                            <StyledList>
                                <StyledListItem>
                                    {Parser(t("analyze_selection.analyze_modal.modal_checklist_1"))}
                                    <p>
                                        {Parser(
                                            t("analyze_selection.analyze_modal.modal_checklist_1_1")
                                        )}
                                        <br />
                                        {Parser(
                                            t(
                                                "analyze_selection.analyze_modal.modal_checklist_1_2",
                                                {
                                                    print_server_setup: printServerSetupLink,
                                                }
                                            )
                                        )}
                                    </p>
                                </StyledListItem>
                                <StyledListItem>
                                    {Parser(t("analyze_selection.analyze_modal.modal_checklist_2"))}
                                    <p>
                                        {Parser(
                                            t("analyze_selection.analyze_modal.modal_checklist_2_1")
                                        )}
                                        <br />
                                        {Parser(
                                            t(
                                                "analyze_selection.analyze_modal.modal_checklist_2_2",
                                                {
                                                    iot_gateway_setup: IOTGatewaySetupLink,
                                                }
                                            )
                                        )}
                                    </p>
                                </StyledListItem>
                            </StyledList>
                        </TextBlock>
                        <FooterContent>
                            <CloseActionButton onClick={onClose}>
                                <CloseButtonText>
                                    {t("analyze_selection.analyze_modal.modal_close")}
                                </CloseButtonText>
                            </CloseActionButton>
                        </FooterContent>
                    </ModalContent>
                </ModalWrapper>
            </div>
        </ModalOverlay>
    );
};

export default AnalyzeSaaSModal;
